import React from 'react';
import cx from 'classnames';
import { compose, defaultProps, setDisplayName } from 'recompose';
import { Divider } from 'components/Layout';
import Sticky from 'components/Sticky';
import styles from './styles.css';

export type Props = {
  baseClassName?: string;
  children?: React.ReactNode;
  className?: string;
  style?: any;
  onClick?: any;
  divider?: 'small' | 'half' | 'none';
  align?: 'left' | 'right' | 'center';
  sticky?: boolean;
};

export type OwnProps = Props & {
  align: string;
  divider: string;
};

const Sticker = ({ children, sticky }) =>
  sticky ? (
    <Sticky
      top={70}
      stickyElementStyle={{ background: 'white', padding: '10px 0' }}
    >
      {children}
    </Sticky>
  ) : (
    children
  );

export const Header = compose<OwnProps, Props>(
  setDisplayName('Header'),
  defaultProps({
    baseClassName: styles.wrapper,
    divider: 'full',
  })
)(
  ({
    children,
    className,
    baseClassName,
    divider,
    align,
    onClick,
    style,
    sticky,
  }) => (
    <div className={cx(styles.root, className)} style={style}>
      <Sticker sticky={sticky}>
        <div className={cx(baseClassName, styles[align])} onClick={onClick}>
          {children}
        </div>
      </Sticker>
      {divider !== 'none' && <Divider size={divider} top={10} />}
    </div>
  )
);
